module.exports = __webpack_public_path__ + "static/media/why-qwark.6d73b423.png";